import { computed } from 'mobx';
// import { computed, observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';

import copyToClipboard from 'copy-to-clipboard';
import AntdMessage from '@src/components/antd/message';

class PublicBetaStore {
  constructor(data) {
    this.mainStore = data.mainStore;
  }

  @computed
  get isActive() {
    return this.mainStore.pageChangeStore.currentPage === 'publicBeta';
  }
  swiperStore = new BaseSwiperStore({
    swiperOptions: {
      effect: 'fade',
      slidesPerView: 1,
      loop: false,
      loopedSlides: 1
    }
  });
  onCopy = text => {
    const success = copyToClipboard(text);
    success ? AntdMessage.success('复制成功') : AntdMessage.fail('复制失败');
  };

  changeTabActiveIndex = index => {
    this.swiperStore.onChange(index);
  };
}

export default PublicBetaStore;
